import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.cust/locations/picker/location-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
//import SalesRepParser from "emun.salesrep/territory-manager/zipcode/parser/zipcode-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class LocationPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setShipIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `location-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setShipIds();
	}
	clearAll() {
		this.selected = {};
		this.setShipIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(location) {
		return !!this.selected[location.id];
	}

	setShipIds() {
		this.shipIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { shipIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(location) {
		const $ctrl = this;
		console.log("toggle", location.id, $ctrl.selected, location);

		if ($ctrl.single) {
			$ctrl.$close(location);
		} else if (location.id in $ctrl.selected) {
			delete $ctrl.selected[location.id];
			$ctrl.onLocationUnSelected &&
				$ctrl.onLocationUnSelected({ $location: location, ...$ctrl });
		} else {
			$ctrl.selected[location.id] = true;
			$ctrl.onLocationSelected &&
				$ctrl.onLocationSelected({ $location: location, ...$ctrl });
		}
		this.setShipIds();
	}
	select(location) {
		const $ctrl = this;
		$ctrl.$close([location]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	//parseZipcodes() {
	//	const $ctrl = this;
	//	ZipcodeParser({}).then(zipcodeIds => {
	//		$ctrl.selected = {};
	//		zipcodeIds.forEach(zipcodeId => {
	//			$ctrl.toggle({ id: zipcodeId });
	//		});
	//		$ctrl.viewSelections = true;
	//		$ctrl.viewSelectionsChanged();
	//	});
	//}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryRetailerShippingLocations.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				"CompanyName": "Name: A to Z",
				"-CompanyName": "Name: Z to A"
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "Id",
			autoLoad: true,
			append: false
		};
	}
}


